const wrap = <T = unknown>(args: T | T[]): T[] => {
  return Array.isArray(args) ? args : [args];
};

export { wrap };
